import { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import Button from '../../../components/Common/Button/Button';
import { WelletContext } from '../../../context/WelletContext';
import { InputSingleCharacter } from '../../../components/Common/InputSingleCharacter/InputSingleCharacter';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import { getQueryString } from '../../../helpers/url';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';
import { exchangeToken } from '../../../actions/associatesActions';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { requestCodeVerificationService, sendCodeVerificationService } from '../../../services/whatsappCode/whatsappCodeService';


const LoginPhoneValidationScreen = ({ history }) => {
  const { t } = useTranslation();
  const tenant = useSelector((state) => state.app.tenantId);
  const app = useSelector((state) => state.app);
  const welletContext = useContext(WelletContext);
  const dispatch = useDispatch();
  const auth = getAuth();
  const email = getQueryString('email');
  const phone = getQueryString('phone');
  const codeLength = 4;
  const [code, setCode] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [btnVerifyDisable, setBtnVerifyDisable] = useState(true);
  const [verifyingCode, setVerifyingCode] = useState(false);
  const [sendingCode, setSendingCode] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(0);

  const onVerifyHandle = (user) => {
    exchangeToken(dispatch, user, () => history.push('/'));
  };

  const requestCodeVerification = async () => {
    if (secondsRemaining > 0) return;
    setSendingCode(true);

    try {
      await sendCodeVerificationService(
        welletContext,
        email,
        tenant,
        app.language
      );
      startTimer();
    } catch (error) {
      console.error(error);
      setErrorCode(t('signUp.errorSendingCode'));
    }

    setSendingCode(false);
  };

  const sendCodeVerification = async (code) => {
    setVerifyingCode(true);

    try {
      const result = await requestCodeVerificationService(
        welletContext,
        email,
        tenant,
        code,
        app.language
      );

      if (result.status === 200) {
        const userCredentials = await signInWithCustomToken(auth, result.data.token);
        onVerifyHandle(userCredentials.user);
      }
    } catch (error) {
      console.error(error);
      setErrorCode(t('signUp.codeError'));
    }

    setVerifyingCode(false);
  };

  const onCodeChange = (value) => {
    setCode(value);
    setErrorCode('');
  };

  const verifyCode = () => sendCodeVerification(code);

  const startTimer = () => setSecondsRemaining(600);

  useEffect(() => {
    const interval = setInterval(() => {
      if (secondsRemaining > 0) {
        setSecondsRemaining((prev) => prev - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsRemaining]);

  useEffect(() => {
    startTimer();
  }, []);

  useEffect(() => {
    setBtnVerifyDisable(code.length !== codeLength);
  }, [code]);

  return (
    <>
      <Header title={''} hasBackground={true} />
      <ContentApp background={true}>
        <div className={`animateIn`}>
          <div className='font-medium bold text-white' style={{ lineHeight: '1.6rem' }}>
            {t('signUp.title2')}
          </div>
          <div className='mt-2 text-secondary subtitle' style={{ lineHeight: '1.3rem' }}>
            {t('signUp.subtitle2')} {phone}
          </div>

          <div className='mt-3'>
            <InputSingleCharacter
              length={codeLength}
              onValueChange={onCodeChange}
            />
          </div>

          {errorCode && (
            <div>
              <ErrorBox title={errorCode} />
            </div>
          )}
        </div>

        <FixedButton>
          <Button
            className={`${verifyingCode ? 'loading' : ''} btn-primary`}
            onClick={verifyCode}
            size='large'
            fontSize='18px'
            disabled={btnVerifyDisable}
            text={
              verifyingCode ? (
                <div className='d-flex justify-content-center'>
                  <Spinner size={25} color='#000' />
                </div>
              ) : (
                t('continue')
              )
            }
            icon={!verifyingCode}
            typeIcon='arrow'
            iconColor='#000'
          />

          <Button
            className='mt-2 btn-primary'
            size='large'
            fontSize='18px'
            onClick={requestCodeVerification}
            disabled={secondsRemaining > 0}
            text={
              sendingCode ? (
                <div className='d-flex justify-content-center'>
                  <Spinner size={25} color='#000' />
                </div>
              ) : (
                <>
                  {secondsRemaining > 0
                    ? `${t('Reenviar código')} ${Math.floor(secondsRemaining / 60)}:${(
                        secondsRemaining % 60
                      )
                        .toString()
                        .padStart(2, '0')}`
                    : t('Reenviar código')}
                </>
              )
            }
            type='button'
          />
        </FixedButton>
      </ContentApp>
    </>
  );
};

export default LoginPhoneValidationScreen;
